module.exports = __webpack_public_path__ + "img/earth.38ab8dda.svg";